<template>
  <section
    id="recent-projects"
    class="hide-overflow"
    dark
  >
  
    <v-layout dark >
      <!-- <v-flex
        xs12
        md6
        primary
        text-xs-center
        pa-5
        white--text
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateX(25%)"
        />
        <base-heading>
          Recent Projects
        </base-heading>

        <base-text class="mb-5">
          Lorem ipsum dolor sit amet, consectetur adipi<br>
          scin elit. Etiam vulputate augue vel felis gravida<br>
          porta. Lorem ipsum dolor sit amet.
        </base-text>

        <v-card color="secondary">
          <v-container
            grid-list-md
            pa-2
          >
            <v-layout wrap>
              <v-flex
                v-for="project in projects"
                :key="project"
                xs12
                md6
              >
                <a href="#">
                  <v-img
                    :src="require(`@/assets/${project}.jpeg`)"
                    max-height="300"
                  />
                </a>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex> -->
        <v-card
    class="mx-auto"
    min-width="600"
    dark
    
  >
    <!-- <v-system-bar
      color="indigo darken-2"
      dark
    >
      <v-spacer></v-spacer>

      <v-icon>mdi-window-minimize</v-icon>

      <v-icon>mdi-window-maximize</v-icon>

      <v-icon>mdi-close</v-icon>
    </v-system-bar>

    <v-toolbar
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>Discover</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar> -->

    <v-container fluid>
      <v-row dense>
        
        <v-col
          v-for="card in cards"
          :key="card.title"
          :cols="card.flex"
        >
        
        <v-card
            :href="card.href"
            target="_blank"
            

          >{{ card.title }}</v-card>
        </v-hover>
          
          <v-card >
            
            <v-img
              :src="card.src"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="200px"
              @click="open(card.href)"
              
              
            >
            
              <v-hover v-slot:default="{ hover }">
              <v-card-title v-text="card.title"
              :elevation="hover ? 12 : 2"></v-card-title>
            </v-hover>
            </v-img>
            
            <!-- <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-bookmark</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions> -->
          </v-card>
          
        </v-col>
      </v-row>
    </v-container>
  </v-card>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/praying.jpg')"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
          cards: [
        { title: 'Youtube Channel', src:require('@/assets/project4.png'), flex: 12, href: 'https://www.youtube.com/channel/UCwObEOZR1mUk3DBFBhUSbFQ'},
        { title: 'My Tutorials Shop', src:require('@/assets/project2.png'), flex: 6, href: 'https://gumroad.com/cryptorootz'},
        { title: 'Github', src:require('@/assets/project1.png'), flex: 6, href: 'https://github.com/CryptoRootz' },
        { title: 'Medium', src:require('@/assets/project3.png'), flex: 6, href: 'https://medium.com/@cryptorootz' }
      ]
  }),
  methods: {
      open(href) {
        window.open(href)
      }
    },
}
</script>
